import moment from 'moment'
import Helpers from '../Helpers'

class LastMinute {
    constructor(resultsClassInstance) {

        this.lastMinuteResults = document.getElementById("last-minute-results");
        this.valid = this.lastMinuteResults !== null;
        if (!this.valid) return; // Guard Clause for if the last min block doesn't exist

        this.mobileBreakPoint = 750;
        this.resultsClass = resultsClassInstance
        this.currentUrl = window.location.href;
        this.pageParams = new URLSearchParams(window.location.search);
        this.resultsListItems = document.querySelector(".results-list__items");
        this.lastMinuteButtons = Array.from(this.lastMinuteResults.querySelectorAll(".date"));

        // Set start date defaults and first button highlight defaults (this could be overridden by url query params)
        this.startDates = {};
        this.setStartDates(this.getDefaultStartDateString(), this.getDefaultEndDateString(), this.getDefaultLengthOfStay());
        this.firstHighlightedButton = this.lastMinuteButtons[0];

        // Start the Last Minute Process
        this.pageLoader();
    }

    //#region Page Load

        pageLoader = () => {

            // Test if we've got a query string for start/end dates
            this.dateRangesInQueryString();

            // Attach click event listeners 
            this.lastMinuteButtonsClick();

            // Fetch first batch of results from default date range
            this.setFirstLastMinuteDate();

        }


    //#endregion


    //#region Query Params - Date Range

        // Query the query string and see if we've start/end dates declared
        dateRangesInQueryString = () => {

            // if we've date params
            if (!this.datesURLQueryParamDetailsExist()) return;

            // create param based default startdate object
            this.setDatesFromURLQueryParams();
        }


        // Check if query params are present to set a default date
        datesURLQueryParamDetailsExist = () => {

            // test dss exist
            if (!this.pageParams.has("dss")) return false;

            // test des exist 
            if (!this.pageParams.has("des")) return false;

            // test length of stay exists
            if (!this.pageParams.has("nday")) return false;

            return true;
        }


        // Check the query params we have exist as an option on the page
        setDatesFromURLQueryParams = () => {

            const start = moment(this.pageParams.get("dss"), "ddd D MMM YY").format("DD/MM/YY"); // expected format "ddd Do MMM YY" then convert to workable dd/mm/yy
            const end = moment(this.pageParams.get("des"), "ddd D MMM YY").format("DD/MM/YY") // expected format "ddd Do MMM YY" then convert to workable dd/mm/yy
            const length = this.pageParams.get("nday");

            // using start date / dss try and get a button
            const targetButton = this.lastMinuteButtons.find(x => x.dataset.startDate === start);

            // Check we've found a button
            if (targetButton === undefined) {

                // url without params
                const url = window.location.href.split('?')[0];

                // Clear locally/class-level stored url query
                this.setLocalCurrentURLRef(url);

                // Push changes to url front end
                history.pushState({}, document.title, url);

                // there's a date range but it doesn't exist in the current options
                return;
            }

            // Check the end date is correct
            if (!targetButton.dataset.endDate === end) return false;

            // Check length of stay is correct
            if (!targetButton.dataset.lengthOfStay === length) return false;

            // Set start/end dates and length of stay
            this.setStartDates(start, end, length);

            // Update Initial button thats highlighted on first load
            this.firstHighlightedButton = targetButton;

            // Highlight date range button
            this.setSelectedDateRangeButton(targetButton);

            return;
        }


    //#endregion

    //#region Utility Functions

        // Query the DOM and find defaults for start/end dates and length of stay
        getDefaultStartDateString = () => this.lastMinuteResults.dataset.defaultStartDate;
        getDefaultEndDateString = () => this.lastMinuteResults.dataset.defaultEndDate;
        getDefaultLengthOfStay = () => this.lastMinuteResults.dataset.defaultLengthOfStay;

        // Class level ref to current state url
        setLocalCurrentURLRef = (url) => this.currentUrl = url;
        setLocalCurrentParams = (url) => this.pageParams = new URLSearchParams(url);

        // get current highlighted details
        getCurrentIndexOfHighlightedButton = () => this.lastMinuteButtons.findIndex(button => button.classList.contains('selected'));

        // set start dates
        setStartDates = (start, end, length) => {
            this.startDates = {
                startDateString: start, // expected format dd/mm/yy
                endDateString: end, // expected format dd/mm/yy
                lengthOfStay: length
            }
        }

        // Highlight selected date range button
        setSelectedDateRangeButton = (button) => {
            this.lastMinuteButtons.forEach(btn => {
                btn.classList.toggle('selected', btn === button);
                btn.classList.toggle('not-selected', btn !== button);
            });
        };


        // After an option is selected, scroll to section
        scrollToResults = () => {
            const belowMobileBreakpoint = window.innerWidth < this.mobileBreakPoint;
            const resultsInViewport = new Helpers(this.resultsListItems).isPartiallyInViewport();

            if (belowMobileBreakpoint && !resultsInViewport) {
                this.resultsListItems.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }

        // Create Date Options, For fetching cottage results
        createUpdateSearchOptions = () => {
            // Get any changes to the search
            return {
                feedEndpoint: this.resultsClass.getFeedEndpoint(),
                updateMetaTitle: false,
                preservePageDescription: true,
                preservePageHeader: true,
                url: this.currentUrl
            }
        }

        // Create a date range object (expected input date string "DD/MM/YY")
        createDateRangeObject = (startDate, endDate, lengthOfStay) => {
            return {
                dss: moment(startDate, "DD/MM/YY").format("ddd D MMM YY"),
                des: moment(endDate, "DD/MM/YY").format("ddd D MMM YY"),
                nday: lengthOfStay
            }
        }

    //#endregion


    //#region First Date Load

        setFirstLastMinuteDate = () => {

            const { startDateString, endDateString, lengthOfStay } = this.startDates;

            // Update UI for default/first date ranges 
            const dateRange = this.createDateRangeObject(startDateString, endDateString, lengthOfStay);
            this.resultsClass.dates.setValues(dateRange);

            // Fetch Cottages for default/first date ranges 
            const options = this.createUpdateSearchOptions();
            this.resultsClass.updateSearch("", options);
        }

    //#endregion


    //#region Click Event of Date Range

        lastMinuteButtonsClick = () => {

            this.lastMinuteButtons.forEach(button => {
                button.addEventListener('click', (e) => {

                    // Highlight clicked button
                    this.setSelectedDateRangeButton(button);

                    // Update UI with new date range
                    const { startDate, endDate, lengthOfStay } = button.dataset; // expected format dd/mm/yy
                    const dateRange = this.createDateRangeObject(startDate, endDate, lengthOfStay);
                    const { fsi, ...queryStringParams } = { ...this.resultsClass.getNonDefaultValues(), ...dateRange };
                    this.resultsClass.dates.setValues(queryStringParams);

                    // Update URL params
                    this.setURLParams(queryStringParams);

                    // Fetch Cottages
                    const options = this.createUpdateSearchOptions();
                    this.resultsClass.updateSearch("", options);

                    // Go to results
                    this.scrollToResults();

                });
            })
        }

        // Set the pages new URL query string (in order to make it sharable)
        setURLParams = (queryStringParams) => {
            let currentUrl = new URL(window.location.href);
            currentUrl.search = `?${this.resultsClass.buildQueryString(queryStringParams)}`;
            history.pushState(queryStringParams, document.title, currentUrl.href);
            // update locally referenced url items
            this.setLocalCurrentURLRef(currentUrl.href);
            this.setLocalCurrentParams(currentUrl.href);
        }

    //#endregion
}

export default LastMinute